"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const atoms_1 = require("@components/atoms");
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var LayoutRule = function LayoutRule(_ref) {
    var className = _ref.className;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Padding, {
        className: className,
        halfPadding: true
    }, /*#__PURE__*/ react_1.default.createElement(Hr, null)));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "LayoutRule__Wrapper",
    componentId: "ubshkg-0"
})(["display:none;", "{display:block;}"], _utils_1.mediaQuery('tablet', 'max'));
var Hr = styled_components_1.default.div.withConfig({
    displayName: "LayoutRule__Hr",
    componentId: "ubshkg-1"
})(["", "{display:block;background-color:", ";width:100%;height:1px;}"], _utils_1.mediaQuery('tablet', 'max'), _utils_1.rgba(_theme_1.palette.ink, 0.32)); // Typing
exports.default = LayoutRule;
